import { createSlice } from "@reduxjs/toolkit";
import { getClaimsStatistics } from "../../reducer/insuranceStatistics/insuranceStatisticsReducer";

const initialState = {
  data: {
    total_approved_amount: 0,
    total_pending_claims: 0,
    total_approved_claims: 0,
    total_rejected_claims: 0,
  },
  isLoading: false,
  error: null,
};

const claimsStatisticsSlice = createSlice({
  name: "claimsStatistics",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getClaimsStatistics.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getClaimsStatistics.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(getClaimsStatistics.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default claimsStatisticsSlice.reducer;
